import {Chip, Typography} from '@mui/material';
import {HarvestDemandPutSpeciesEnum} from 'client';
import {useTranslation} from 'react-i18next';

const SpeciesChip = ({species}: {species: string}) => {
  const {t} = useTranslation('common');

  return (
    <Chip
      size="small"
      label={<Typography variant="body3">{t(species)}</Typography>}
      sx={{
        height: 22,
        backgroundColor: species === HarvestDemandPutSpeciesEnum.Salmon ? 'error.light' : 'success.light',
        color: species === HarvestDemandPutSpeciesEnum.Salmon ? 'error.contrastText' : 'success.contrastText',
      }}
    />
  );
};

export const CardSpeciesTag = ({species}: {species: string}) => {
  const {t} = useTranslation('common');

  return (
    <Chip
      size="small"
      label={t(species)}
      sx={{
        backgroundColor: species === HarvestDemandPutSpeciesEnum.Salmon ? 'error.light' : 'success.light',
        color: species === HarvestDemandPutSpeciesEnum.Salmon ? 'error.contrastText' : 'success.contrastText',
        fontSize: '0.75rem',
        letterSpacing: 0.4,
        height: 18,
        marginRight: 0.5,
        fontWeight: 600,
        minWidth: 50,
        marginBottom: 0.3,
      }}
    />
  );
};

export default SpeciesChip;
